import * as graphql from 'generated/graphql';

import CompetencyInput from './CompetencyInput';
import OpenQuestionInput from './OpenQuestionInput';
import ReviewGoalsInput from './ReviewGoalsInput';
import SentimentInput from './SentimentInput';
import StarsInput from './StarsInput';

export default function EvaluationSubmissionItemInput(props: {
	submission: graphql.EvaluationSubmission;
	item: graphql.EvaluationSectionItem;
	metadata?: { goal: graphql.EvaluationSubmissionGoal };
	party: graphql.EvaluationSubmissionParty;
	initialValue?:
		| graphql.EvaluationSubmissionItem['competency']
		| graphql.EvaluationSubmissionItem['developmentPlan']
		| graphql.EvaluationSubmissionItem['multipleChoice']
		| graphql.EvaluationSubmissionItem['openQuestion']
		| graphql.EvaluationSubmissionItem['reviewGoals']
		| graphql.EvaluationSubmissionItem['sentiment']
		| graphql.EvaluationSubmissionItem['stars'];
	name: string;
}) {
	if (props.item.type === graphql.EvaluationSectionItemType.OpenQuestion) {
		return <OpenQuestionInput name={props.name} initialValue={props.initialValue} />;
	}

	if (props.item.type === graphql.EvaluationSectionItemType.Competency) {
		return (
			<CompetencyInput
				name={props.name}
				competency={props.item.competency!}
				party={props.party}
				initialValue={props.initialValue}
			/>
		);
	}

	if (props.item.type === graphql.EvaluationSectionItemType.Sentiment) {
		return <SentimentInput name={props.name} initialValue={props.initialValue} />;
	}

	if (props.item.type === graphql.EvaluationSectionItemType.Stars) {
		return <StarsInput name={props.name} initialValue={props.initialValue} />;
	}

	if (props.item.type === graphql.EvaluationSectionItemType.ReviewGoals) {
		return (
			<ReviewGoalsInput
				name={props.name}
				competencyLevelSet={props.item.reviewGoals!.competencyLevelSet}
				submission={props.submission}
				initialValue={props.initialValue}
				metadata={props.metadata!}
			/>
		);
	}

	return null;
}
